export function flattenMongoSchema(user) {
    return {
        // Personal Info
        firstName: user.personalDetails?.firstName || "",
        middleName: user.personalDetails?.middleName || "",
        lastName: user.personalDetails?.lastName || "",
        dob: formatDateRaw(user.personalDetails?.dob),
        gender: user.personalDetails?.gender || "Female",
        category: user.personalDetails?.category || "",


        // Contact Info
        email: user.contactDetails?.email || "",
        mobile: user.contactDetails?.mobile || "",
        whatsappMobile: user.contactDetails?.whatsappMobile || "",
        currentAddress: user.contactDetails?.currentAddress || "",
        permanentAddress: user.contactDetails?.permanentAddress || "",

        // Coaching Info
        coachingBy: user.academicDetails?.coaching?.coachingBy || "Others",
        coachingByOthers: user.academicDetails?.coaching?.coachingByOthers || "",

        // Family Info
        fatherName: user.familyDetails?.father?.name || "",
        fatherOccupation: user.familyDetails?.father?.occupation || "",
        fatherMobile: user.familyDetails?.father?.mobile || "",
        fatherAadhar: user.familyDetails?.father?.aadhar || "",
        fatherIncome: user.familyDetails?.father?.income || "",

        motherName: user.familyDetails?.mother?.name || "",
        motherOccupation: user.familyDetails?.mother?.occupation || "",
        motherMobile: user.familyDetails?.mother?.mobile || "",
        motherAadhar: user.familyDetails?.mother?.aadhar || "",
        motherIncome: user.familyDetails?.mother?.income || "",

        familyIncome: user.familyDetails?.familyIncome || "",

        numSiblings: user.familyDetails?.numSiblings || 0,
        siblings: user.familyDetails?.siblings || [],

        // Class 10
        board10: user.academicDetails?.tenth?.board || "",
        math10: user.academicDetails?.tenth?.math || "",
        science10: user.academicDetails?.tenth?.science || "",
        english10: user.academicDetails?.tenth?.english || "",
        school10: user.academicDetails?.tenth?.school || "",
        state10: user.academicDetails?.tenth?.schoolState || "",
        schoolType10: user.academicDetails?.tenth?.schoolType || "",
        overall10: user.academicDetails?.tenth?.overall || "",

        // Class 12
        board12: user.academicDetails?.twelth?.board || "",
        math12: user.academicDetails?.twelth?.math || "",
        physics12: user.academicDetails?.twelth?.physics || "",
        english12: user.academicDetails?.twelth?.english || "",
        school12: user.academicDetails?.twelth?.school || "",
        state12: user.academicDetails?.twelth?.schoolState || "",
        schoolType12: user.academicDetails?.twelth?.schoolType || "",
        overall12: user.academicDetails?.twelth?.overall || "",

        // JEE Mains S1
        jeeMainsS1Roll: user.academicDetails?.jeeMains?.session1?.roll || "",
        jeeMainsS1: user.academicDetails?.jeeMains?.session1?.total || "",
        jeeMainsS1Physics: user.academicDetails?.jeeMains?.session1?.physics || "",
        jeeMainsS1Chemistry: user.academicDetails?.jeeMains?.session1?.chemistry || "",
        jeeMainsS1Math: user.academicDetails?.jeeMains?.session1?.math || "",

        // JEE Mains S2
        jeeMainsS2Roll: user.academicDetails?.jeeMains?.session2?.roll || "",
        jeeMainsS2: user.academicDetails?.jeeMains?.session2?.total || "",
        jeeMainsS2Physics: user.academicDetails?.jeeMains?.session2?.physics || "",
        jeeMainsS2Chemistry: user.academicDetails?.jeeMains?.session2?.chemistry || "",
        jeeMainsS2Math: user.academicDetails?.jeeMains?.session2?.math || "",

        // JEE Advanced
        jeeAllIndiaRank: user.academicDetails?.jeeMains?.jeeAllIndiaRank || "",
        jeeAdvancedEligible: user.academicDetails?.jeeMains?.jeeAdvancedEligible || "No",

        // Attachments
        attachments: user.attachments || [],

        // Application Status
        applicationSubmitted: user.applicationSubmitted,
    };
}

function formatDateRaw(date) {
    if (!date) return "";
    return new Date(date).toISOString().substring(0, 10); // yyyy-mm-dd
}
